import HeatingEnergy from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/HeatingEnergy'
import HotwaterEnergy from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/HotwaterEnergy'
import CookingEnergy from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/CookingEnergy'
import Surface from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/Surface'
import useAddress from '../../useAddress'
import { StyledTitle } from '@/containers/SubscriptionFormPageNew/Panel/styled-components'

const Consumption = () => {
  const { t, showConsumption } = useAddress()

  if (!showConsumption) return null

  return (
    <>
      <StyledTitle>{t('subscriptionForm:address_v2.consumption_title')}</StyledTitle>
      <HeatingEnergy />
      <HotwaterEnergy />
      <CookingEnergy />
      <Surface />
    </>
  )
}

export default Consumption
